<template>
  <div class="main-container">
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1>Boost Your Business with our AI Powered Assistants</h1>
          <p>Turn your knowledge into smarter customer interactions and deeper engagement.
          </p>
          <div class="hero-button-container">
            <RouterLink to="/register" class="pill-button accent">Get Started Now</RouterLink>
          </div>
        </div>
        <div class="hero-image">
          <img src="../assets/hero2.png" alt="hero image">
        </div>
      </div>
    </section>

    <section class="features" id="features">
      <div class="container">
        <h2>Key Platform Features</h2>
        <div class="feature-grid">
          <div class="feature">
            <span class="material-icons">rocket_launch</span>
            <h3>Have a working AI assistant in minutes</h3>
            <p>Deploy your AI Assistant with a single click, making integration seamless and efficient.</p>
          </div>
          <div class="feature">
            <span class="material-icons">library_add</span>
            <h3>Instantly add your custom knowledge base</h3>
            <p>Quickly incorporate your business's knowledge base, enabling the assistant to answer details of your
              business.</p>
          </div>
          <div class="feature">
            <span class="material-icons">code</span>
            <h3>Embed your AI assistent in your website</h3>
            <p>Once trained your custom AI assistent can be embedded in your website or app.</p>
          </div>
          <div class="feature">
            <span class="material-icons engage-icon">handshake</span>
            <h3>Engage visitors & supercharge support</h3>
            <p>Help users find the answer they need instantly with a chatbot that understands your website and products.
            </p>
          </div>
          <div class="feature">
            <span class="material-icons">transfer_within_a_station</span>
            <h3>Live Agent Handoff</h3>
            <p>If customers need more help, seamlessly handover to regular human live chat in the same platform.</p>
          </div>
          <div class="feature">
            <span class="material-icons">visibility</span>
            <h3>Monitor conversations in realtime</h3>
            <p>See your visitors chatting with your AI assistant in realtime. Browse all historical conversations.</p>
          </div>
          <div class="feature">
            <span class="material-icons">chat</span>
            <h3>Custom welcome message</h3>
            <p>Set a custom welcome message for visitors, set conversation starters to get customers engaging.</p>
          </div>
          <div class="feature">
            <span class="material-icons">palette</span>
            <h3>Fully customisable branding and styling</h3>
            <p>Tailor your AI Assistant to your brand, brand tone, pallet and logos.</p>
          </div>
          <div class="feature">
            <span class="material-icons">analytics</span>
            <h3>Data Insights and engagement analytics</h3>
            <p>Gain valuable insights into customer behavior and preferences through the engagement platform analytics
              dashboard.</p>
          </div>
          <div class="feature">
            <span class="material-icons">palette</span>
            <h3>FAQ Generation recommendations</h3>
            <p>Your AI assistant highlights unanswered customer questions, helping refine its knowledge to serve them
              better.</p>
          </div>
          <div class="feature">
            <span class="material-icons">settings_suggest</span>
            <h3>Conversation Analytics</h3>
            <p>Advanced AI capabilities, including converstaion evaluation, topic assignment and misunderstood query
              identification.</p>
          </div>
          <div class="feature">
            <span class="material-icons">support_agent</span>
            <h3>24/7 Support</h3>
            <p>Provide instant support to your customers anytime, day or night.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="pricing" id="pricing">
      <div class="container">
        <h2>Choose your plan</h2>
        <div class="pricing-grid">
          <!-- <div class="plan-card">
            <h3>Trial</h3>
            <p class="plan-price">Free Trial for 7 Days</p>
            <ul class="plan-features">
              <li> Get started with... </li>
              <li> <span class="material-icons plan-checkmark">check_circle</span> 200 message on FREE Trial </li>
              <li> <span class="material-icons plan-checkmark">check_circle</span> 2000 characters responses per message
              </li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Customise your AI Agent look and feel
              </li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Upload your own document to the agent
              </li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Conversation Analysis</li>
            </ul>
            <RouterLink to="/register" class="pill-button primary">Try Free</RouterLink>
          </div> -->
          <div class="plan-card">
            <h3>Basic</h3>
            <p class="plan-price">R999/month</p>
            <ul class="plan-features">
              <li> Everything in Free plus... </li>
              <li><span class="material-icons plan-checkmark">check_circle</span> 5000 messages per month</li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Up to 25m characters in conversations
              </li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Live agent handoff</li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Advanced customisation options</li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Self learning agent module</li>
              <li><span class="material-icons plan-checkmark">check_circle</span> On demand topup for more chats</li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Upload multiple documents to the agent
              </li>
            </ul>
            <RouterLink to="/register" class="pill-button accent">Get Started</RouterLink>
          </div>
          <div class="plan-card">
            <h3>Pro</h3>
            <p class="plan-price">R4999/month</p>
            <ul class="plan-features">
              <li> Everthing in basic plus... </li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Unlimited Conversations</li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Up to 250m characters in conversations
              </li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Remove Novare Branding</li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Bring your own AI API KEY</li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Sentiment and Conversation Analysis
              </li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Integration into messaging plaforms
              </li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Up to 3 live agent handoff</li>
              <li><span class="material-icons plan-checkmark">check_circle</span> Dedicated account manager</li>
            </ul>
            <a href="#" class="pill-button ghost">Contact us</a>
          </div>
        </div>
        <div class="custom-plan-card">
          <h3>Enterprise plan</h3>
          <p>Need more? Tell us about your needs.</p>
          <ul class="plan-features two-column">
            <li><span class="material-icons plan-checkmark">check_circle</span>Unlimited messages and storage capacity
            </li>
            <li><span class="material-icons plan-checkmark">check_circle</span>Priority + Zoom support</li>
            <li><span class="material-icons plan-checkmark">check_circle</span>Enterprise SOC2 Security</li>
            <li><span class="material-icons plan-checkmark">check_circle</span>Custom Database integrations</li>
            <li><span class="material-icons plan-checkmark">check_circle</span>Custom onboarding</li>
            <li><span class="material-icons plan-checkmark">check_circle</span>Unlimited workflows</li>
          </ul>
          <a href="#" class="pill-button ghost">Contact us</a>
        </div>
      </div>
    </section>
    <!-- <section class="compare-plans" id="compare-plans">
      <div class="container">
        <h2>Compare Plans</h2>
        <div class="compare-table">
          <div class="table-header">
            <div class="header-cell">Features</div>
            <div class="header-cell">Trial</div>
            <div class="header-cell">Basic</div>
            <div class="header-cell">Pro</div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Conversations per month
              <span class="tooltip-icon" data-tooltip="Number of conversations per month">?</span>
            </div>
            <div class="cell">100</div>
            <div class="cell">1000</div>
            <div class="cell">Unlimited</div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Team members
              <span class="tooltip-icon" data-tooltip="Number of team members that can access the platform">?</span>
            </div>
            <div class="cell">1</div>
            <div class="cell">1</div>
            <div class="cell">Unlimited</div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Number of Chatbots
              <span class="tooltip-icon" data-tooltip="How many chatbots can you build on each plan.">?</span>
            </div>
            <div class="cell">1</div>
            <div class="cell">3</div>
            <div class="cell">Unlimited</div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Integrations
              <span class="tooltip-icon" data-tooltip="Connect your business data to your AI chatbot">?</span>
            </div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark">check_circle</span></div>
            <div class="cell"><span class="material-icons plan-checkmark">check_circle</span></div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Access to AI models
              <span class="tooltip-icon" data-tooltip="Access to the latest AI models (eg GPT-4)">?</span>
            </div>
            <div class="cell">GPT-3.5</div>
            <div class="cell">GPT-3.5</div>
            <div class="cell">GPT-4</div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Custom Workflows
              <span class="tooltip-icon" data-tooltip="Create custom workflows to handle more complex logic.">?</span>
            </div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark">check_circle</span></div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Upload data sources
              <span class="tooltip-icon"
                data-tooltip="Upload files such as PDFs, CSVs, and TXTs to the chatbot's knowledge base">?</span>
            </div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark">check_circle</span></div>
            <div class="cell"><span class="material-icons plan-checkmark">check_circle</span></div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              App integrations (via Zapier)
              <span class="tooltip-icon"
                data-tooltip="Connect your AI chatbot to third-party apps, such as CRMs">?</span>
            </div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark">check_circle</span></div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Custom API
              <span class="tooltip-icon"
                data-tooltip="Connect your AI chatbot to third-party apps, such as CRMs">?</span>
            </div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Real-time analytics
              <span class="tooltip-icon" data-tooltip="Access to real-time chat analytics">?</span>
            </div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark">check_circle</span></div>
            <div class="cell"><span class="material-icons plan-checkmark">check_circle</span></div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Priority support
              <span class="tooltip-icon" data-tooltip="Access to priority technical support">?</span>
            </div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark">check_circle</span></div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell">
              Dedicated account manager
              <span class="tooltip-icon"
                data-tooltip="Dedicated account manager to help you with setup, configuration and best practices">?</span>
            </div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark plan-cross">close</span></div>
            <div class="cell"><span class="material-icons plan-checkmark">check_circle</span></div>
          </div>
          <div class="table-row">
            <div class="cell feature-cell"></div>
            <div class="cell"><RouterLink to="/register" class="pill-button primary">Try Free</RouterLink></div>
            <div class="cell"><RouterLink to="/register" class="pill-button accent">Get Started</RouterLink></div>
            <div class="cell"><a href="#" class="pill-button ghost">Contact Us</a></div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
  <footer class="glass-footer">
    <div class="container footer-inner">
      <div class="footer-meta">
        <p>© 2025 Novare. All rights reserved.</p>
      </div>
      <span class="version-pill">v2.1</span>
    </div>
    <div class="footer-links">
      <a href="https://www.novare.co.za/public/privacy_policy.txt" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      |
      <a href="https://www.novare.co.za/public/terms_of_service.txt" target="_blank" rel="noopener noreferrer">Tems of Service</a>
    </div>
  </footer>
</template>

<script>
// import FreeSimpleChatbotButton from "../components/SimpleChatbotFree.vue";

export default {
  name: "HomePage",
  components: {
    //  FreeSimpleChatbotButton,
  }
};
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  gap: 80px;
  margin-top: 90px;
  color: var(--text-primary);
}

.container {
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  padding: 0 16px;
}

.hero {
  padding: 4.5rem 0 5rem;
  position: relative;
}

.hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.08), transparent 35%),
    radial-gradient(circle at 80% 0%, rgba(251, 146, 60, 0.15), transparent 40%);
  pointer-events: none;
}

.hero .container {
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  align-items: center;
  gap: 32px;
  z-index: 1;
}

.hero-content h1 {
  font-size: clamp(2.5rem, 4vw, 3.8rem);
  line-height: 1.1;
  margin-bottom: 16px;
  font-weight: 700;
  background: linear-gradient(90deg, #fff 0%, #facc15 40%, #f97316 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-content p {
  margin-bottom: 20px;
  font-size: 1.05rem;
  color: var(--text-muted);
  max-width: 640px;
}

.hero-button-container {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.hero-image img {
  width: 100%;
  max-width: 520px;
  border-radius: var(--radius-2xl);
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-card);
}

.features {
  padding: 80px 0;
  background: linear-gradient(180deg, rgba(17, 24, 39, 0.7) 0%, rgba(0, 0, 0, 0.8) 100%);
}

.features h2 {
  font-size: 2rem;
  margin-bottom: 28px;
  text-align: center;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
}

.feature {
  padding: 24px;
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-card);
  text-align: left;
  backdrop-filter: blur(12px);
}

.feature .material-icons {
  font-size: 44px;
  color: var(--accent-orange);
  margin-bottom: 12px;
}

.feature h3 {
  margin: 0 0 8px;
  color: var(--text-primary);
}

.feature p {
  margin: 0;
  color: var(--text-muted);
}

.pricing {
  padding: 80px 0;
  background: linear-gradient(180deg, rgba(12, 18, 30, 0.8) 0%, rgba(0, 0, 0, 0.92) 100%);
}

.pricing h2 {
  font-size: 2rem;
  margin-bottom: 28px;
  text-align: center;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  column-gap: 24px;
  row-gap: 64px;
  align-items: stretch;
}

.plan-card,
.custom-plan-card {
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-card);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  backdrop-filter: blur(12px);
}

.plan-card:hover,
.custom-plan-card:hover {
  transform: translateY(0);
  transition: box-shadow 0.2s ease;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.55);
}

.plan-price {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--accent-orange);
  margin: 0 0 8px;
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;
  color: var(--text-muted);
}

.plan-features.two-column {
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.plan-features li {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto 1fr;
  align-items: center;
  gap: 8px;
}

.plan-checkmark {
  font-size: 1rem;
  background: linear-gradient(90deg, var(--accent-orange) 0%, var(--accent-orange-hover) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.plan-cross {
  color: var(--error);
  -webkit-text-fill-color: var(--error);
}

.plan-card .pill-button,
.custom-plan-card .pill-button {
  margin-top: auto;
  align-self: flex-start;
}

.custom-plan-card {
  grid-column: 1 / -1;
  margin-top: 5px;
}

.custom-plan-card p {
  margin: 0;
  color: var(--text-muted);
}

.compare-plans {
  padding: 80px 0;
}

.compare-table {
  display: grid;
  gap: 16px;
}

.table-header,
.table-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  padding: 12px 16px;
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-card);
  backdrop-filter: blur(10px);
}

.header-cell {
  font-weight: 700;
}

.cell {
  text-align: center;
  color: var(--text-secondary);
}

.feature-cell {
  text-align: left;
  color: var(--text-primary);
}

.tooltip-icon {
  display: inline-block;
  margin-left: 6px;
  font-size: 0.9em;
  color: var(--accent-orange);
  cursor: pointer;
  position: relative;
}

.tooltip-icon:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  background: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 8px;
  border-radius: 6px;
  top: 110%;
  left: 50%;
  transform: translateX(-50%);
  white-space: normal;
  z-index: 5;
  font-size: 0.9em;
  width: 220px;
  text-align: center;
  box-sizing: border-box;
}

footer {
  margin-top: 20px;
  padding: 18px 0;
  background: var(--bg-glass);
  border-top: 1px solid var(--border-color);
  backdrop-filter: blur(10px);
}

footer p {
  margin: 0;
  color: var(--text-secondary);
  text-align: center;
}

.glass-footer {
  background: linear-gradient(180deg, rgba(17, 24, 39, 0.85) 0%, rgba(0, 0, 0, 0.9) 100%);
  border-top: 1px solid var(--border-color);
  backdrop-filter: blur(12px);
  box-shadow: var(--shadow-nav);
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px;
}

.footer-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  font-size: 12px;
  margin-top: 8px;
  width: 100%;
}

.footer-links a {
  color: var(--text-secondary);
  text-decoration: none;
}

.footer-links a:hover {
  color: var(--text-primary);
  text-decoration: underline;
}

.version-pill {
  padding: 6px 10px;
  border-radius: var(--radius-pill);
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  font-family: ui-monospace, SFMono-Regular, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
}

@media (max-width: 768px) {
  .main-container {
    gap: 56px;
  }

  .hero {
    padding: 3.5rem 0 4rem;
  }

  .table-header,
  .table-row {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }
}
</style>
